let data_layers = {};
const LayersUtils = {
  /**
   *
   * @param {object} params
   * @param {funtion} callback
   */
  getLayers: function (marco, callback) {
    let me = this;
    if (!data_layers.items) {
      fetch(window.Config.MAP_URL)
        .then(res => res.text())
        .then(
          result => {
            const parser = new DOMParser();
            const xmlprocess = parser.parseFromString(result, "text/xml");
            const xml = me.xmlToJson(xmlprocess);
            const layers = [];
            let groups = [];
            xml.nodes.node.forEach(function (item) {
              groups.push(item.grupo);
            });
            let uniqueGroups = groups.filter(
              (val, id, array) => array.indexOf(val) === id
            );
            uniqueGroups.sort((a, b) => {
              const from = a.split(".");
              const to = b.split(".");
              return from[0] - to[0];
            });
            xml.nodes.node.forEach(function (item, i) {
              let child = {};
              child.order = i;
              child.id = item.id + "wms";
              if (item.servicio.includes("WMS")) {
                child.type = "wms";
              } else if (item.servicio.includes("WFS")) {
                child.type = "wfs";
              } else {
                child.type = "kml";
              }
              //child.type = item.servicio.includes("WMS") ? "wms" : "kml";
              child.group = item.grupo;
              if (item.servicio.includes("WMS")) {
                child.url = item.url_wms;
              } else if (item.servicio.includes("WFS")) {
                child.url = item.url_wms;
              } else {
                child.url = item.url_kml;
              }
              //child.url = item.servicio.includes("WMS")? item.url_wms: item.url_kml;
              child.url = child.url.toString().replace("?", "");
              child.visible = false;
              child.layerName = item.nombre_capa;
              child.label = item.titulo;
              child.fuente = item.fuente;
              let url_link = item.url_link;
              if (url_link.toString() === "[object Object]") {
                url_link = "#";
              }
              child.link = url_link;
              if (me.validUrl(child.url)) {
                layers.push(child);
              }
            });
            let main_layer = [];
            uniqueGroups.forEach(function (item, i) {
              let child_layer = [];
              layers.forEach(function (child, j) {
                if (child.group === item) {
                  child_layer.push(child);
                }
              });
              main_layer.push({
                name: item,
                child: child_layer
              });
            });
            let mydata_layer = [];
            layers.forEach(function (item, j) {
              if (item.visible) {
                mydata_layer.push({
                  url: item.url,
                  visible: item.visible,
                  layerName: item.layerName,
                  type: item.type,
                  label: item.label,
                  id: item.id,
                  checked: false,
                  link: item.link,
                  selected: item.visible ? "checked" : "",
                  init: true,
                  fuente: item.fuente
                });
              }
            });
            data_layers.visibles = mydata_layer;
            data_layers.items = main_layer;
            if (data_layers.items.length > 0) {
              let _layers = [];
              data_layers.items.forEach(function (item, i) {
                const strings = item.name.split(".");
                if (marco.includes(strings[0])) {
                  _layers = item;
                }
              });
              callback(_layers);
            }
          },
          error => {
            callback(data_layers);
          }
        );
    } else {
      if (data_layers.items.length > 0) {
        let _layers = [];
        data_layers.items.forEach(function (item, i) {
          const strings = item.name.split(".");
          if (marco.includes(strings[0])) {
            _layers = item;
          }
        });
        callback(_layers);
      }
    }
  },
  getAllLayers: function (callback) {
    let me = this;
    fetch(window.Config.MAP_URL)
      .then(res => res.text())
      .then(
        result => {
          const parser = new DOMParser();
          const xmlprocess = parser.parseFromString(result, "text/xml");
          const xml = me.xmlToJson(xmlprocess);
          const layers = [];
          let groups = [];
          xml.nodes.node.forEach(function (item) {
            groups.push(item.grupo);
          });
          let uniqueGroups = groups.filter(
            (val, id, array) => array.indexOf(val) === id
          );
          uniqueGroups.sort((a, b) => {
            const from = a.split(".");
            const to = b.split(".");
            return from[0] - to[0];
          });
          xml.nodes.node.forEach(function (item, i) {
            let child = {};
            child.order = i;
            child.id = item.id + "wms";
            if (item.servicio.includes("WMS")) {
              child.type = "wms";
            } else
              if (item.servicio.includes("WFS")) {
                child.type = "wfs";

              } else {
                child.type = "kml";
              }
            child.group = item.grupo;
            if (item.servicio.includes("WMS")) {
              child.url = item.url_wms;
            } else
              if (item.servicio.includes("WFS")) {
                child.url = item.url_wms;
              } else {
                child.url = item.url_kml;
              }
            child.url = child.url.toString().replace("?", "");
            let isTrueSet = item.visible === "true";
            child.visible = isTrueSet;
            child.layerName = item.nombre_capa;
            child.label = item.titulo;
            child.fuente = item.fuente;
            let url_link = item.url_link;
            if (url_link.toString() === "[object Object]") {
              url_link = "#";
            }
            child.link = url_link;
            if (me.validUrl(child.url)) {
              layers.push(child);
            }
          });
          let main_layer = [];
          uniqueGroups.forEach(function (item) {
            let child_layer = [];
            layers.forEach(function (child) {
              if (child.group === item) {
                child_layer.push(child);
              }
            });
            main_layer.push({
              name: item,
              child: child_layer
            });
          });
          let mydata_layer = [];
          layers.forEach(function (item) {
            if (item.visible) {
              mydata_layer.push({
                url: item.url,
                visible: item.visible,
                layerName: item.layerName,
                type: item.type,
                label: item.label,
                id: item.id,
                checked: true,
                selected: item.visible ? "checked" : "",
                init: true,
                link: item.link,
                fuente: item.fuente
              });
            }
          });
          callback({
            layers: main_layer,
            dataLayer: mydata_layer,
            dataLegend: mydata_layer
          }, true);
        },
        error => {
          callback({}, false);
        }
      );
  },
  validUrl: function (url) {
    var a = document.createElement("a");
    a.href = url;
    return a.host && a.host !== window.location.host;
  },
  xmlToJson(xml) {
    let me = this;
    var obj = {};
    if (xml.nodeType === 1) {
      if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
        for (var j = 0; j < xml.attributes.length; j++) {
          var attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) {
      obj = xml.nodeValue;
    }
    if (
      xml.hasChildNodes() &&
      xml.childNodes.length === 1 &&
      xml.childNodes[0].nodeType === 3
    ) {
      obj = xml.childNodes[0].nodeValue;
    } else if (xml.hasChildNodes()) {
      for (var i = 0; i < xml.childNodes.length; i++) {
        var item = xml.childNodes.item(i);
        var nodeName = item.nodeName;
        if (typeof obj[nodeName] === "undefined") {
          obj[nodeName] = me.xmlToJson(item);
        } else {
          if (typeof obj[nodeName].push === "undefined") {
            var old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(me.xmlToJson(item));
        }
      }
    }
    return obj;
  }
};
export default LayersUtils;
